// Babel polyfill
import 'babel-polyfill';

// UIkit Icons
import Icons from 'uikit/dist/js/uikit-icons';

// loads the Icon plugin
UIkit.use(Icons);

global.UIkit = UIkit;

export const breakPoints = {
    small:  600,
    medium: 768,
    large:  960,
    xlarge: 1200,
};

export const breakPointsMax = {
    small:  600 - 1,
    medium: 768 - 1,
    large:  960 - 1,
    xlarge: 1200 - 1,
}
